import request from '@/utils/request';

//管控标记-列表
export function fetchControlMarkOptions(data) {
  return request(`/api/control-mark/list`, {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}

//部门管控标记-配置列表
export function fetchPartControlMarkList(data) {
  return request(`/api/part-control-mark/list`, {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}

//部门管控标记-批量创建
export function createControlMark(data) {
  return request(`/api/control-mark/create`, {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}
//部门管控标记-批量清除
export function batchDeletePartControlMarkList(data) {
  return request(`/api/part-control-mark/batch-delete`, {
    method: 'POST',
    data,
  });
}
//部门管控标记-批量设置
export function batchSetPartControlMark(data) {
  return request(`/api/part-control-mark/batch-set`, {
    method: 'POST',
    data,
    removeBlankProperty: true,
  });
}
